import ProtectedMenuItemLink from "../ProtectedMenuItemLink";
import SubMenu from "../SubMenu";
import React, { FC } from "react";
import assignments from "../../../pages/assignments";
import RoutePlannerIcon from "@material-ui/icons/Explore";
import drivers from "../../../pages/drivers";
import busAssistants from "../../../pages/busAssistants";
import vehicles from "../../../pages/vehicles";
import notTakings from "../../../pages/notTakings";
import notTakingStudents from "../../../pages/notTakingStudents";
import { useSelector } from "react-redux";
import { AppState } from "../Menu";
import ListAltIcon from "@material-ui/icons/ListAlt";
import SectionComponent from "../SectionComponent";
import dryRunSchedules from "pages/dryRunSchedules";
import excludeBusAssistants from "pages/excludeBusAssistants";
import adhocOperators from "pages/adhocOperators";

interface OperationServicesMenuProps {
  permissions: string[];
}

const OperationServicesMenu: FC<OperationServicesMenuProps> = ({
  permissions,
}) => {
  const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);

  const availableResources = [
    "totalNoOfAssignments",
    "assignments",
    "busSchedulePlans",
    "enhancedBusSchedulePlans",
    "drivers",
    "busAssistants",
    "vehicles",
    "notTakings",
    "notTakingStudents",
    "dryRunSchedules",
    "excludeBusAssistants",
    "adhocOperators",
  ];

  if (permissions.length === 0) {
    return <></>;
  }

  // Give specific show menu access based on resource
  const findResources = permissions.filter((permission) =>
    availableResources.includes(permission),
  );
  if (findResources.length === 0) {
    return <></>;
  }

  return (
    <SectionComponent name={open ? "Operation Services" : "OS"}>
      <ProtectedMenuItemLink
        to={`/totalNoOfAssignments`}
        primaryText={"Total Assignments"}
        leftIcon={<ListAltIcon />}
        permissions={permissions}
        permissionResource="totalNoOfAssignments"
      />
      <ProtectedMenuItemLink
        to={`/assignments`}
        primaryText={"Bus Services"}
        leftIcon={<assignments.icon />}
        permissions={permissions}
        permissionResource="assignments"
      />
      <ProtectedMenuItemLink
        to={`/busSchedulePlans`}
        primaryText={"Route Plans"}
        leftIcon={<RoutePlannerIcon />}
        permissions={permissions}
        permissionResource="busSchedulePlans"
      />
      {/*<ProtectedMenuItemLink*/}
      {/*  to={`/enhancedBusSchedulePlans`}*/}
      {/*  primaryText={*/}
      {/*    <Stack direction="row" style={{ width: "100%" }}>*/}
      {/*      <span>AI Route Plans</span>*/}
      {/*      <span*/}
      {/*        style={{*/}
      {/*          fontSize: "12px",*/}
      {/*          backgroundColor: "#f44336",*/}
      {/*          borderRadius: "30%",*/}
      {/*          color: "white",*/}
      {/*          padding: "2px 4px",*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        new*/}
      {/*      </span>*/}
      {/*    </Stack>*/}
      {/*  }*/}
      {/*  leftIcon={<enhancedRoutePlans.icon />}*/}
      {/*  permissions={permissions}*/}
      {/*  permissionResource="busSchedulePlans"*/}
      {/*/>*/}
      <ProtectedMenuItemLink
        to={`/drivers`}
        primaryText={"Drivers"}
        leftIcon={<drivers.icon />}
        permissions={permissions}
        permissionResource="drivers"
      />
      <ProtectedMenuItemLink
        to={`/busAssistants`}
        primaryText={"Bus Assistants"}
        leftIcon={<busAssistants.icon />}
        permissions={permissions}
        permissionResource="busAssistants"
      />
      <ProtectedMenuItemLink
        to={`/vehicles`}
        primaryText={"Vehicles"}
        leftIcon={<vehicles.icon />}
        permissions={permissions}
        permissionResource="vehicles"
      />
      <ProtectedMenuItemLink
        to={`/adhocOperators`}
        primaryText={"Adhoc Operators"}
        leftIcon={<adhocOperators.icon />}
        permissions={permissions}
        permissionResource="adhocOperators"
      />
      <SubMenu
        name="Not Takings"
        icon={<notTakings.icon />}
        permissions={permissions}
        permissionResources={["notTakings", "notTakingStudents"]}
      >
        <ProtectedMenuItemLink
          to={`/notTakings`}
          primaryText={"Not Taking Students"}
          leftIcon={<notTakings.icon />}
          permissions={permissions}
          permissionResource="notTakings"
        />
        <ProtectedMenuItemLink
          to={`/notTakingStudents`}
          primaryText={"Exclude Students"}
          leftIcon={<notTakingStudents.icon />}
          permissions={permissions}
          permissionResource="notTakingStudents"
        />
      </SubMenu>
      <ProtectedMenuItemLink
        to={`/excludeBusAssistants`}
        primaryText={"Exclude Bus Assistants"}
        leftIcon={<excludeBusAssistants.icon />}
        permissions={permissions}
        permissionResource="excludeBusAssistants"
      />
      <ProtectedMenuItemLink
        to={`/dryRunSchedules`}
        primaryText={"Dry Run Schedules"}
        leftIcon={<dryRunSchedules.icon />}
        permissions={permissions}
        permissionResource="dryRunSchedules"
      />
    </SectionComponent>
  );
};

export default OperationServicesMenu;
